(() => {
  const story = document.querySelector('[data-slim-story]');
  if (!story) return;
  const variants = JSON.parse(document.querySelector('#slim-variants').textContent);
  const options = index => [...document.querySelectorAll(`#pdp-form [data-option-index="${index}"] .opt`)];
  const sync = () => {
    const id = document.querySelector('#pdp-variant-id')?.value;
    const variant = variants.find(item => String(item.id) === String(id));
    if (!variant) return;
    story.querySelectorAll('[data-slim-color-panel]').forEach(panel => {
      panel.hidden = panel.dataset.slimColorPanel !== variant.option3;
    });
    story.querySelectorAll('[data-slim-format]').forEach(button => {
      button.setAttribute('aria-pressed', String(variant.option1 === button.dataset.slimFormat));
    });
    story.querySelectorAll('[data-slim-color]').forEach(button => {
      button.setAttribute('aria-pressed', String(variant.option3 === button.dataset.slimColor));
    });
  };
  story.querySelectorAll('[data-slim-format]').forEach(button => {
    button.addEventListener('click', () => {
      options(1).find(option => option.dataset.value === button.dataset.slimFormat)?.click();
      sync();
    });
  });
  story.querySelectorAll('[data-slim-color]').forEach(button => {
    button.addEventListener('click', () => {
      options(3).find(option => option.dataset.value === button.dataset.slimColor)?.click();
      sync();
    });
  });
  story.querySelectorAll('[data-slim-quote]').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelector('[data-angebot] [data-quote-trigger]')?.click();
      if (button.dataset.slimQuote !== 'custom') return;
      const message = document.querySelector('#quote-nachricht');
      if (message && !message.value.trim()) {
        message.value = story.dataset.slimCustomMessage;
        message.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  });
  document.addEventListener('fennext:variant', sync);
  sync();
})();
